import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import * as api from '../../api/AccountsAPI/verifyPartialFDAPI';

const err = (e, fallback) => e?.ErrorDetails?.ErrorMessage || e?.Message || e?.message || fallback;

export const fetchVerifyPartialFDQueue = createAsyncThunk(
    'verifyPartialFD/fetchQueue',
    async ({ roleId, mode }, { rejectWithValue }) => {
        try { return await api.getVerificationPartialFDs(roleId, mode); }
        catch (e) { return rejectWithValue(err(e, 'Failed to fetch Partial FD verification queue')); }
    }
);

export const fetchVerifyPartialFDDetail = createAsyncThunk(
    'verifyPartialFD/fetchDetail',
    async ({ transactionNo, mode }, { rejectWithValue }) => {
        try { return await api.getPartialFDByTransNo(transactionNo, mode); }
        catch (e) { return rejectWithValue(err(e, 'Failed to fetch partial FD details')); }
    }
);

export const submitApprovePartialFD = createAsyncThunk(
    'verifyPartialFD/approve',
    async (payload, { rejectWithValue }) => {
        try { return await api.approvePartialFD(payload); }
        catch (e) { return rejectWithValue(err(e, 'Error Occurred')); }
    }
);

const initialState = {
    queue: [], queueLoading: false, queueError: null,
    detail: null, detailLoading: false, detailError: null,
    verifyLoading: false,
};

const verifyPartialFDSlice = createSlice({
    name: 'verifyPartialFD',
    initialState,
    reducers: {
        clearVerifyPartialFDDetail: (s) => { s.detail = null; s.detailError = null; s.detailLoading = false; },
        resetVerifyPartialFD: () => initialState,
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchVerifyPartialFDQueue.pending, (s) => { s.queueLoading = true; s.queueError = null; })
            .addCase(fetchVerifyPartialFDQueue.fulfilled, (s, a) => { s.queueLoading = false; s.queue = a.payload?.Data || []; })
            .addCase(fetchVerifyPartialFDQueue.rejected, (s, a) => { s.queueLoading = false; s.queueError = a.payload; s.queue = []; });

        builder
            .addCase(fetchVerifyPartialFDDetail.pending, (s) => { s.detailLoading = true; s.detailError = null; s.detail = null; })
            .addCase(fetchVerifyPartialFDDetail.fulfilled, (s, a) => { s.detailLoading = false; s.detail = a.payload?.Data || null; })
            .addCase(fetchVerifyPartialFDDetail.rejected, (s, a) => { s.detailLoading = false; s.detailError = a.payload; s.detail = null; });

        builder
            .addCase(submitApprovePartialFD.pending, (s) => { s.verifyLoading = true; })
            .addCase(submitApprovePartialFD.fulfilled, (s) => { s.verifyLoading = false; })
            .addCase(submitApprovePartialFD.rejected, (s) => { s.verifyLoading = false; });
    },
});

export const { clearVerifyPartialFDDetail, resetVerifyPartialFD } = verifyPartialFDSlice.actions;

export const selectVPFQueue = (s) => s.verifyPartialFD.queue;
export const selectVPFQueueLoading = (s) => s.verifyPartialFD.queueLoading;
export const selectVPFQueueError = (s) => s.verifyPartialFD.queueError;
export const selectVPFDetail = (s) => s.verifyPartialFD.detail;
export const selectVPFDetailLoading = (s) => s.verifyPartialFD.detailLoading;
export const selectVPFDetailError = (s) => s.verifyPartialFD.detailError;
export const selectVPFVerifyLoading = (s) => s.verifyPartialFD.verifyLoading;

export default verifyPartialFDSlice.reducer;
